import type { useTranslations } from 'next-intl';

export const BYWAY_FAVOURITE_RANKING_THRESHOLD = 200;

export const isBywayFavouriteAccommodation = (ranking: number) => ranking >= BYWAY_FAVOURITE_RANKING_THRESHOLD;

// clean up DOTW descriptions
const removeAfterComma = (str: string | null) => {
  if (str) {
    // remove everything after and including first comma
    return str.replace(/,.*$/, '');
  }
  return '';
};

const sentenceCaseDescription = (str: string | null) => {
  if (str) {
    const sanitizedDesc = removeAfterComma(str);
    return sanitizedDesc.charAt(0).toUpperCase() + sanitizedDesc.substring(1).toLowerCase();
  }
  return '';
};

// expand board basis code into a translated label
const expandedBoardBasis = (t: ReturnType<typeof useTranslations<'journey'>>, code: string | null) => {
  const sanitizedCode = removeAfterComma(code);

  switch (sanitizedCode) {
    case 'AI':
      return t('board_basis_ai');
    case 'BB':
    case 'BREAKFAST':
      return t('board_basis_bb');
    case 'FB':
      return t('board_basis_fb');
    case 'HB':
      return t('board_basis_hb');
    case 'RO':
    case 'ROOM_ONLY':
      return t('board_basis_ro');
    default:
      return sentenceCaseDescription(sanitizedCode);
  }
};

const sanitzeBoardBasis = (code: string | null) => {
  const sanitizedCode = removeAfterComma(code);
  const boardBasis = {
    AI: 'AI',
    BB: 'BB',
    BREAKFAST: 'BB',
    FB: 'FB',
    HB: 'HB',
    RO: 'RO',
    ROOM_ONLY: 'RO'
  };

  return boardBasis[sanitizedCode] ? boardBasis[sanitizedCode] : sentenceCaseDescription(sanitizedCode);
};

export { expandedBoardBasis, removeAfterComma, sentenceCaseDescription, sanitzeBoardBasis };
